(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('specialConnectionService', specialConnectionService)

    specialConnectionService.$inject = ['$http', 'CONFIG', 'messageService'];


    function specialConnectionService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/connections';
            var service = {
                getConnections: getConnections,
                getConnectionsSsr: getConnectionsSsr,
                deleteSpecialConnection: deleteSpecialConnection,
                saveSpecialConnection: saveSpecialConnection
            };

        return service;

        function getConnections(departureDate){
            return $http.get(urlBase + "/"+departureDate)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.connections : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getConnectionsSsr(departureDate, classificationSsrId) {
            return $http.get(urlBase + "/date/ssr/"+departureDate+"?classificationSsrId="+classificationSsrId)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.connections : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveSpecialConnection(specialConnection, userLogin){
            return $http.post(urlBase+"?user_login="+ userLogin, specialConnection)
                .then(function(response){
                    messageService.register('');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function deleteSpecialConnection(connectionId, userLogin){
            return $http.delete(urlBase + '/' + connectionId+"?user_login="+ userLogin)
                .then(function(){
                    messageService.registerDelete('');
                })
                .catch(function(){
                    messageService.registerDeleteError('');
                });
        }
    }
})();
